import { render } from "./RevealSlider.vue?vue&type=template&id=c3446016&scoped=true&ts=true"
import script from "./RevealSlider.vue?vue&type=script&lang=ts"
export * from "./RevealSlider.vue?vue&type=script&lang=ts"

import "./RevealSlider.vue?vue&type=style&index=0&id=c3446016&lang=scss&scoped=true"

import exportComponent from "/Users/iti/Documents/icandy_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3446016"]])

export default __exports__